<template>
  <div class="container-fluid discover-moods">
    <div class="container">
      <template v-if="isMobile()">
        <div class="row justify-content-center mobile-moods">
          <div class="col-11">
            <img
              v-if="currentLang === 'en'"
              src="@/assets/img/discover/mood-top-en.png"
              alt=""
            />
            <img v-else src="@/assets/img/discover/mood-top-es.png" alt="" />
          </div>
          <div class="col-11">
            <h2  class="moods-title">{{ $t("discover.moods.title") }}</h2>
            <p  class="moods-subtitle">{{ $t("discover.moods.subtitle") }}</p>
            <router-link v-if="!isLoggedIn" class="btn red-button" :to="'/register'">
              {{ $t("discover.moods.trynow") }}
            </router-link>
            <a v-else class="btn red-button" color="primary" @click.prevent="toggleShowDownload">
              {{ $t("discover.moods.trynow") }}
            </a>
          </div>
          <div class="col-11">
            <img
              v-if="currentLang === 'en'"
              src="@/assets/img/discover/mood-bottom-en.png"
              alt=""
            />
            <img v-else src="@/assets/img/discover/mood-bottom-es.png" alt="" />
          </div>
        </div>
      </template>
      <template v-else>
        <div class="row align-items-center">
          <div class="col-6">
            <h3 class="moods-title">{{ $t("discover.moods.title") }}</h3>
            <p class="moods-subtitle">{{ $t("discover.moods.subtitle") }}</p>            
            <router-link v-if="!isLoggedIn" class="btn red-button" :to="'/register'">
              {{ $t("discover.moods.trynow") }}
            </router-link>
            <a v-else class="btn red-button" color="primary" @click.prevent="toggleShowDownload">
              {{ $t("discover.moods.trynow") }}
            </a>
          </div>
          <div class="col-6 moods-image">
            <img src="@/assets/img/discover-moods.png" alt="" />
          </div>
        </div>
      </template>
    </div>
  </div>
  <download-app-dialog
    v-model="showDownloadAppDialog"
    :displayDialog="showDownloadAppDialog"
    dialogType="moods"
    :is-mobile="mobile"
    :is-android="android"
    :is-iphone="iphone"
  />
</template>

<script>
import { UserStore } from '@/stores/userStore';
import { mapState } from 'pinia';
import DownloadAppDialog from '../dialogs/DownloadAppDialog.vue';

export default {
  name: "DiscoverByMood",
  components: {
    DownloadAppDialog
  },
  data:()=>{
    return {showDownloadAppDialog: false}
  },
  methods: {
    toggleShowDownload(){
      this.showDownloadAppDialog = !this.showDownloadAppDialog;
    }
  },
  computed: {
    ...mapState(UserStore, ["isLoggedIn"]),
    currentLang() {
      return this.$i18n.locale;
    },
    mobile() {
      return this.isMobile();
    },
    android() {
      return this.isAndroid();
    },
    iphone() {
      return this.isIphone();
    }
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/colors";
.discover-moods {
  margin-top: 2em;
  padding: 2em 0;
  position: relative;
  background: linear-gradient(356.13deg,
        rgba(20, 28, 45, 0.3) -13.92%,
        rgba(19, 28, 45, 0.3) 121.92%
      );
  background-size: cover, 6%;

  &:before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    width: 100%;
    left: 0;
    height: 0.5px;
    background: url("@/assets/img/divider-line.png") no-repeat center center;
  }

  .moods-title {
    font-size: 2.8em;
  }

  .moods-subtitle {
    font-size: 1.3em;
    margin: 1.5em 0;
  }

  .mobile-moods {
    margin: 3em 0;
    img {
      margin-bottom: 2em;
    }
    h2 {
      text-align: center;
    }
    .moods-title {
      font-size: 2em;
    }

    .moods-subtitle {
      font-size: 1em;
    }

    p {
      text-align: center;
      color: $gray-3;
    }
    .red-button {
      // width: 320px;
      margin: 2em auto;
      display: block;
    }
  }

  
  @media (min-width: 1920px) {
    font-size: 0.8vw;
    .container{
      max-width: none;
      width: 65%;
    }
    .moods-image {
      img{
        width: 100%;
      }
    }
  }
}
</style>
